import {
  Button,
  Card,
  Container,
  HeaderProfile,
  InputCheckboxField,
  InputField,
  InputLabel,
  InputStarsField,
  InputWrapper,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Formik } from 'formik';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { EducatorWriteReviewFormValues, EducatorWriteReviewPageProps } from './types';

export * from './types';

export const EducatorWriteReviewPage: FC<EducatorWriteReviewPageProps> = (props) => {
  const { form, header } = props;
  const { translate } = useTranslation();

  const tooltips = useMemo((): string[] => {
    const list = ['horrible', 'bad', 'good', 'verygood', 'excellent'];
    return list.map((x) => translate(`glossary.${x}`));
  }, [translate]);

  return (
    <>
      <HeaderProfile {...header} />
      <Container>
        <Card>
          <Formik<EducatorWriteReviewFormValues> {...form} enableReinitialize>
            {({ submitForm, isSubmitting }) => (
              <>
                <InputWrapper>
                  <InputWrapper split>
                    <InputLabel>{translate('common.inputs.educatorNote.label')}</InputLabel>
                  </InputWrapper>
                  <InputWrapper split last>
                    <InputStarsField name="grade" tooltips={tooltips} />
                  </InputWrapper>
                </InputWrapper>

                <InputWrapper>
                  <InputLabel required>{translate('common.inputs.opinion.label')}</InputLabel>
                  <InputField
                    textarea
                    name="description"
                    placeholder={translate('common.inputs.opinion.placeholder')}
                  />
                </InputWrapper>

                <InputWrapper>
                  <InputCheckboxField name="acceptedTerms">
                    {translate('common.inputs.termsPolicyProReview.label')}
                  </InputCheckboxField>
                </InputWrapper>

                <Button color="blue" onClick={submitForm} loading={isSubmitting}>
                  {translate('common.buttons.send')}
                </Button>
              </>
            )}
          </Formik>
        </Card>
      </Container>
    </>
  );
};
